import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "home l-main" }
const _hoisted_2 = { class: "c-sec u-bg02 no-style-tag" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "c-sec__title" }, "人気タグ", -1)
const _hoisted_4 = { class: "l-inner" }
const _hoisted_5 = { class: "c-tag-list" }
const _hoisted_6 = { class: "c-sec no-style-category" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "c-sec__title" }, "カテゴリ", -1)
const _hoisted_8 = { class: "l-inner" }
const _hoisted_9 = { class: "c-cate-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")!
  const _component_TopNewsSwiperComponent = _resolveComponent("TopNewsSwiperComponent")!
  const _component_RgTopComponent = _resolveComponent("RgTopComponent")!
  const _component_ClientCustomComponent = _resolveComponent("ClientCustomComponent")!
  const _component_NkCnbcMenuComponent = _resolveComponent("NkCnbcMenuComponent")!
  const _component_MovieFilmComponent = _resolveComponent("MovieFilmComponent")!
  const _component_TopRankingComponent = _resolveComponent("TopRankingComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_vue_element_loading, {
      active: _ctx.isloading,
      "is-full-screen": "",
      spinner: "ring",
      size: "128",
      color: "#ccc",
      "background-color": "rgba(240,240,240,.8)"
    }, null, 8, ["active"]),
    _createVNode(_component_TopNewsSwiperComponent),
    _createVNode(_component_RgTopComponent, {
      company: "users",
      keyword: "rgtop"
    }),
    _createVNode(_component_ClientCustomComponent, {
      type: "company",
      company: _ctx.currentUser.company,
      device: "pc"
    }, null, 8, ["company"]),
    _createVNode(_component_NkCnbcMenuComponent),
    _createVNode(_component_MovieFilmComponent, {
      bgDark: true,
      listTitle: _ctx.recommendTitle,
      company: _ctx.currentUser.company,
      keyword: "recommend"
    }, null, 8, ["listTitle", "company"]),
    _createVNode(_component_MovieFilmComponent, {
      bgDark: false,
      listTitle: "今視聴されている講座",
      company: _ctx.currentUser.company,
      keyword: "now"
    }, null, 8, ["company"]),
    _createVNode(_component_ClientCustomComponent, {
      type: "rgcontent",
      company: "users",
      device: "pc"
    }),
    (_ctx.adPermission)
      ? (_openBlock(), _createBlock(_component_ClientCustomComponent, {
          key: 0,
          type: "advertisement",
          company: "users",
          device: "pc"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_TopRankingComponent),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTopRecommends(), (tp, i) => {
      return (_openBlock(), _createBlock(_component_MovieFilmComponent, {
        key: tp.id,
        bgDark: (i % 2 == 1),
        listTitle: tp.title,
        company: "users",
        keyword: tp.id
      }, null, 8, ["bgDark", "listTitle", "keyword"]))
    }), 128)),
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFrequentTags(), (tag) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tag.id
            }, [
              _createVNode(_component_router_link, {
                to: { path: `/tag/${tag.type}/${tag.id}` }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategoryTags(), (tag, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tag.id
            }, [
              _createVNode(_component_router_link, {
                to: { path: `/tag/${tag.type}/${tag.id}` },
                class: _normalizeClass(`is-0${(i % 5) + 1}`)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}